import {
  RESET_CARACTERISTICAS_PRODUCT_SELECT,
  SET_CARACTERISTICAS_PRODUCT_SELECT,
  InitialState,
  CompraOnlineState,
  CompraOnlineActions,
  GET_PRODUCTS_ECOMMERCE,
  GET_PRODUCTS_ECOMMERCE_SUCCEEDED,
  GET_PRODUCTS_ECOMMERCE_ERROR,
  GET_CARACTERISTICAS,
  GET_CARACTERISTICAS_SUCCEEDED,
  GET_CARACTERISTICAS_ERROR,
  SET_IS_PRICE_FINAL,
  GET_PRODUCTOS_CARACTERISTICAS,
  GET_PRODUCTOS_CARACTERISTICAS_SUCCESS,
  GET_PRODUCTOS_CARACTERISTICAS_ERROR,
} from './types'
import { status } from '../../typeStatus'

const CompraOnlineReducer = (
  state: CompraOnlineState = InitialState,
  action: CompraOnlineActions
): CompraOnlineState => {
  switch (action.type) {
    case SET_CARACTERISTICAS_PRODUCT_SELECT: {
      return {
        ...state,
        caracteristicasProductSelect: action.payload,
      }
    }
    case RESET_CARACTERISTICAS_PRODUCT_SELECT: {
      return {
        ...state,
        caracteristicasProductSelect: null,
      }
    }
    case GET_PRODUCTS_ECOMMERCE: {
      return {
        ...state,
        productsEcommerce: null,
        statusProductsEcommerce: status.loading,
      }
    }
    case GET_PRODUCTS_ECOMMERCE_SUCCEEDED: {
      return {
        ...state,
        productsEcommerce: action.payload,
        statusProductsEcommerce: status.success,
      }
    }
    case GET_PRODUCTS_ECOMMERCE_ERROR: {
      return {
        ...state,
        productsEcommerce: null,
        statusProductsEcommerce: status.error,
      }
    }
    case GET_CARACTERISTICAS: {
      return {
        ...state,
        caracteristicasStatus: status.loading,
      }
    }
    case GET_CARACTERISTICAS_SUCCEEDED: {
      const { caracteristicas } = state
      const caracteristicasProducto = caracteristicas.concat([action.payload])

      return {
        ...state,
        caracteristicas: caracteristicasProducto,
        caracteristicasStatus: status.success,
      }
    }
    case GET_CARACTERISTICAS_ERROR: {
      return {
        ...state,
        caracteristicasStatus: status.error,
      }
    }
    case SET_IS_PRICE_FINAL: {
      return {
        ...state,
        isPriceFinalByCurrentCountry: action.payload,
      }
    }
    case GET_PRODUCTOS_CARACTERISTICAS:
      return { ...state, productosCaracteristicasStatus: status.loading }

    case GET_PRODUCTOS_CARACTERISTICAS_SUCCESS:
      const { productosCaracteristicas } = state
      const nuevasCaracteristicas = action.payload || []

      // Filtra las caracteristicas que ya existen en el store
      const caracteristicasUnicas = nuevasCaracteristicas.filter(
        (nuevaCaracteristica) =>
          !productosCaracteristicas.some(
            (caracteristicaExistente) =>
              caracteristicaExistente.productoId === nuevaCaracteristica.productoId &&
              caracteristicaExistente.zona === nuevaCaracteristica.zona &&
              caracteristicaExistente.descripcion === nuevaCaracteristica.descripcion
          )
      )

      // Concatena solo las caracteristicas que no estan duplicadas
      const updatedCaracteristicas = productosCaracteristicas.concat(caracteristicasUnicas)

      return {
        ...state,
        productosCaracteristicas: updatedCaracteristicas,
        productosCaracteristicasStatus: status.success,
      }

    case GET_PRODUCTOS_CARACTERISTICAS_ERROR:
      return { ...state, productosCaracteristicasStatus: status.error }

    default:
      return state
  }
}

export default CompraOnlineReducer
